// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

// FlipCameraIcon is a "switch camera" glyph — a camera body with a circular-arrows motif
// around the lens (the universally-recognised front/back flip symbol, à la Telegram),
// which antd's icon set doesn't ship.
export function FlipCameraIcon({ style }: { readonly style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" style={{ fontSize: "1em", ...style }} aria-hidden="true">
      {/* camera body */}
      <path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h2L8 5h8l1.5 2h2A1.5 1.5 0 0 1 21 8.5v9A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" />
      {/* circular flip arrows around the lens */}
      <path d="M14.6 12.5a2.7 2.7 0 0 0-5-1.1" />
      <path d="M9.4 12.5a2.7 2.7 0 0 0 5 1.1" />
      <path d="M9.2 9.3v1.6h1.6" />
      <path d="M14.8 14.7v-1.6h-1.6" />
    </svg>
  );
}
